<!-- Copy: P6:1581 (h1), :1581 (sub), :1584-1586 (drop, consent), Reading :1583. No prototype-only card (P6:1589-1591). -->
<h1 class="cx-h1">Start with your CV</h1>
<p class="cx-sub">We read your full academic CV and match it to occupations built from current job postings.</p>

@switch (Mode) {
  @case ('failed') {
    <agu-state-panel Variant="error" Icon="file"
        Title="We could not read your CV"
        Body="The file looks like a scanned image, so there is no text for us to read. Try a PDF exported from Word or Google Docs."
        PrimaryLabel="Choose another file" SecondaryLabel="Use my AGU profile instead"
        Foot="The file is saved for job matching; nothing was sent for career paths."
        (Primary)="ChooseAnother.emit()" (Secondary)="UseProfile.emit()" />
  }
  @case ('not-processed') {
    <div class="cx-drop cx-np">
      <div class="cx-chip">{{ FileName }}</div>
      @if (NotProcessed) {
        <h2>{{ NotProcessed.Title }}</h2>
        <p class="dsub">{{ NotProcessed.Body }}</p>
      }
      <button class="cx-btn sec" type="button" (click)="ChooseAnother.emit()">Choose another file</button>
    </div>
  }
  @default {
    <div class="cx-drop" id="cxDrop" (dragover)="OnDragOver($event)" (drop)="OnStrayDrop($event)">
      <div class="cx-up" aria-hidden="true">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 16V4"/><path d="m7.5 8.5 4.5-4.5 4.5 4.5"/><path d="M4 15v3.5A1.5 1.5 0 0 0 5.5 20h13a1.5 1.5 0 0 0 1.5-1.5V15"/></svg>
      </div>
      @if (Mode === 'reading') {
        <h2>{{ Heading }}</h2>
        <div class="cx-steps">
          @for (step of Steps; track step; let i = $index) {
            <div [class]="StepClass(i)"><i></i>{{ step }}</div>
          }
        </div>
      } @else {
        <agu-file-drop Variant="bare"
            Title="Upload your full academic CV"
            Hint="Drag a PDF here, or click to browse."
            Note="PDF for career paths; DOCX and TXT are saved for job matching only"
            ButtonLabel="Select CV"
            [Accept]="Accept" [MaxBytes]="MaxBytes" [Disabled]="!Consent" [Busy]="Uploading"
            (FileChosen)="FileChosen.emit($event)" (Rejected)="OnRejected($event)" (BlockedClick)="Refused.emit(ConsentCopy)">
          <!-- P6:1585, between the hint and the button it gates -->
          <label class="cx-consent">
            <input type="checkbox" [checked]="Consent" (change)="OnConsent($event)" />
            <span>I understand my CV will be read by AI to extract my profile and suggest career paths.
              @if (PrivacyUrl) { <a [href]="PrivacyUrl" target="_blank" rel="noopener">Privacy policy</a> }</span>
          </label>
        </agu-file-drop>
        @if (UploadError) { <p class="cx-error" role="alert">{{ UploadError }}</p> }
        @if (CanKeep) { <button class="cx-link" type="button" (click)="Keep.emit()">Keep my current CV</button> }
      }
    </div>
  }
}
